import styled from 'styled-components'

export const LockedStatus = styled.div`
  font-size: 14px;
  line-height: 17px;
  color: #B1BFC5;
`
